// Include all function that need to be run on page load

console.log('⭐ [Premier] Premier Additions are active');

document.addEventListener("DOMContentLoaded", function () {

    //console.log('doc ready - premier-additions is active');
    layoutContainerContentWrapper()
    setImageBackground()
    createButtonGroups()
    contentLayout1BgClr()
    toggleAccordion()
    

});

window.addEventListener('load', function() {
    centerSponsorSliderLogos()
});